import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoAndroid16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><path d="M5.38363 1.01266C5.34497 1.01969 5.30514 1.02672 5.27116 1.05015C5.13408 1.14271 5.10362 1.33485 5.19618 1.47193L5.84291 2.43734C4.84352 2.96692 4.09837 3.8468 3.85584 4.90243H12.1415C11.899 3.8468 11.1539 2.96692 10.1545 2.43734L10.8012 1.47193C10.8938 1.33485 10.8633 1.14271 10.7262 1.05015C10.588 0.95759 10.397 0.997425 10.3044 1.1345L9.59209 2.18427C9.09766 2.00385 8.56106 1.90309 7.99869 1.90309C7.43631 1.90309 6.89971 2.00385 6.40529 2.18427L5.69294 1.1345C5.62382 1.0314 5.49845 0.990396 5.38363 1.01266ZM6.34905 3.40276C6.59743 3.40276 6.79895 3.60428 6.79895 3.85266C6.79895 4.10221 6.59743 4.30256 6.34905 4.30256C6.09949 4.30256 5.89915 4.10221 5.89915 3.85266C5.89915 3.60428 6.09949 3.40276 6.34905 3.40276ZM9.64833 3.40276C9.89788 3.40276 10.0982 3.60428 10.0982 3.85266C10.0982 4.10221 9.89788 4.30256 9.64833 4.30256C9.39994 4.30256 9.19842 4.10221 9.19842 3.85266C9.19842 3.60428 9.39994 3.40276 9.64833 3.40276ZM2.8998 5.5023C2.40304 5.5023 2 5.90533 2 6.4021V10.6012C2 11.0979 2.40304 11.501 2.8998 11.501C3.00525 11.501 3.10601 11.4787 3.19974 11.4447V5.55854C3.10601 5.52456 3.00525 5.5023 2.8998 5.5023ZM3.79961 5.5023V12.1009C3.79961 12.5964 4.20381 13.0007 4.69941 13.0007H11.298C11.7936 13.0007 12.1978 12.5964 12.1978 12.1009V5.5023H3.79961ZM13.0976 5.5023C12.9921 5.5023 12.8914 5.52456 12.7976 5.55854V11.4447C12.8914 11.4776 12.9921 11.501 13.0976 11.501C13.5943 11.501 13.9974 11.0979 13.9974 10.6012V6.4021C13.9974 5.90533 13.5943 5.5023 13.0976 5.5023ZM4.99934 13.6005V14.8003C4.99934 15.4622 5.53712 16 6.19908 16C6.86104 16 7.39882 15.4622 7.39882 14.8003V13.6005H4.99934ZM8.59856 13.6005V14.8003C8.59856 15.4622 9.13633 16 9.79829 16C10.4603 16 10.998 15.4622 10.998 14.8003V13.6005H8.59856Z" fill={iconColor} /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoAndroid16;